module.exports = __webpack_public_path__ + "img/be_get.4f66004.png";